import { ManagedObject }       from '@app/shared/models/managed-object.model';
import { RequestState }        from '@core/interfaces/api.interface';
import { IClientEntityEvents } from '@core/interfaces/entity.interface';

// ENUMS #############################################################
// API enums *********************************************************
export enum ClientStatusEnum {
	ENABLED = 'enabled',
	DISABLED = 'disabled'
}

// UI enums *********************************************************


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ClientTMO {
	public created?: Date = undefined;
	public description: string = undefined;
	public id: string = undefined;
	public managedObject: ManagedObject = new ManagedObject();
	public name: string = undefined;
	public status: ClientStatusEnum = undefined;
	public tenantId: string = undefined;
	public userId: string = undefined;
}

export class CreatedClientTMO extends ClientTMO {
	public password?: string = undefined;
}

export class ClientSecretTMO {
	password: string = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class Client extends ClientTMO {
	public etag?: string = undefined;

	public managedObjectName?: string = undefined;

	public ui?: IClientEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {
			update: {
				isEnabled: false,
				showLoader: false
			},
			delete: {
				isEnabled: false,
				showLoader: false
			}
		}
	};
}

export class ClientSecret extends ClientSecretTMO {}

export class CreatedClient extends CreatedClientTMO {}

